import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios';
import 'vuetify/dist/vuetify.min.css';

Vue.config.productionTip = false;

//axios.defaults.baseURL = "https://localhost:7254/";
axios.defaults.baseURL = "https://unlabccback.rocol.org/";
//axios.defaults.baseURL = "https://unlabcc_test_back.rocol.org/";

// Obtener el token almacenado en el local storage
const token = localStorage.getItem('token');

// Establecer el token de autorización en los headers de Axios
axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

export const bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
